
import { get, post, getList, put, DELETE } from './tools';
import * as config from './config';
import {SITE_ROLE_ADMIN_ROLES} from "./config";

// Get server configuration
export const getServerConfig = () => get({ url: config.GET_SERVER_CONFIG });

// Register
export const signUp = data => post({
    url: config.SIGNUP,
    data: {
        email: data.email,
        password: data.password
    },
});

// Login
export const login = data => post({
    url: config.LOGIN,
    data: {
        email: data.email,
        password: data.password,
        remember: data.remember
    },
});

// ADMIN_USER_INFO get user info
export const getUserInfo = () => get({ url: config.ADMIN_USER_INFO });

// Logout
export const logout = (data) => get({
    url: config.LOGOUT,
    // params: data
});

// List API
export const getTenantsData = (data) => getList({
    url: config.GET_TENANTS_DATA,
    params: data
});

// SITE_RELEASE_LOG
export const getUpdateLog = (data) => getList({
    url: config.SITE_RELEASE_LOG,
    params: data
});

export const postUpdateLog = data => post({
    url: config.SITE_RELEASE_LOG,
    data: data
});

export const delUpdateLog = data => put({
    url: config.SITE_RELEASE_LOG,
    data: data
});

export const getDeleteUserList = (data) => getList({
    url: config.SITE_DELETE_USER,
    params: data
});

export const postDeleteUser = data => post({
    url: config.SITE_DELETE_USER,
    data: data
});

// GET_PUT_SITE_CONFIG_SUPPORT
export const getSiteConfigSupport = (data) => get({
    url: config.GET_PUT_SITE_CONFIG_SUPPORT,
    params: data
});

// GET_PUT_SITE_CONFIG_SUPPORT
export const putSiteConfigSupport = data => put({
    url: config.GET_PUT_SITE_CONFIG_SUPPORT,
    data: data
});

// GET_GA_TO_SUBSCRIPTION
export const getGaToSubscription = (data) => get({
    url: config.GA_TO_SUBSCRIPTION,
    params: data
});

// POST_GA_TO_SUBSCRIPTION
export const postGaToSubscription = data => post({
    url: config.GA_TO_SUBSCRIPTION,
    data
});

export const getAdminList = (data) => get({
    url: config.GET_ADMIN_LIST,
    params: data
});

export const putDisableAdmin = data => put({
    url: config.PUT_DISABLE_ADMIN + '/' + data
});

export const putEnableAdmin = data => put({
    url: config.PUT_ENABLE_ADMIN + '/' + data
});

export const getRoleList = (data) => get({
    url: config.GET_ROLE_LIST,
    params: data
});

export const delRole = (data) => DELETE({
    url: config.DEL_ROLE_LIST + '/' + data,
});

export const getResourceList = (data) => get({
    url: config.GET_RESOURCE_LIST,
    params: data
});

export const postCreateAdmin = data => post({
    url: config.POST_CREATE_ADMIN,
    data
});

export const delAdmin = (data) => DELETE({
    url: config.API_ADMIN + '/' + data,
});

export const putAdmin = data => put({
    url: config.API_ADMIN + '/' + data.id,
    data: {
        role_ids: data.role_ids,
    }
});

export const getPolicyList = (data) => get({
    url: config.GET_POLICY_LIST,
    params: data
});

export const postCreateRole = data => post({
    url: config.POST_CREATE_ROLE,
    data
});

export const getPermissions = (data) => get({
    url: config.API_ADMIN + '/' + data.id + '/permissions',
    params: data
});

export const putRole = data => put({
    url: config.DEL_ROLE_LIST + '/' + data.id,
    data: {...data.data}
});

export const getAdminLogList = (data) => get({
    url: config.GET_ADMIN_LOG_LIST,
    params: data
});

export const ssoLogin = (data) => get({
    url: config.SITE_SSO_LOGIN,
    params: data
});
export const getSiteRoleAdminRoles = (data) => get({
    url: `${config.SITE_ROLE_ADMIN_ROLES}/${data.id}`,
    params: data.params
});

// GET_COUNTRY_LIST
export const getCountryList = (data) => get({
    url: config.GET_COUNTRY_LIST,
    params: data
});

export const changeUserRegion = (data) => post({
    url: config.CHANGE_USER_REGION + '?region=' + data.region,
    data: data.list
});

// GET_USER_INFO - Get user info by email
export const getUserInfoByEmail = (email) => get({
    url: config.GET_USER_INFO,
    params: { email }
});

// UPDATE_USER_COUNTRY - Update user country
export const updateUserCountry = (data) => put({
    url: config.UPDATE_USER_COUNTRY,
    data: {
        userId: data.userId,
        country: data.country
    }
});
